// extracted by mini-css-extract-plugin
module.exports = {"searchKeyWrap":"styles_searchKeyWrap__2-gH-","buttonSearch":"styles_buttonSearch__2gxj5"};